import React from 'react';
import { Button } from '@cloudscape-design/components';
import { useCopilot } from './CopilotContext';
import { CURRENT_STAGE, Stage } from 'src/contstant/apiEndpoints';
import './Copilot.css';

// Feature flag: only show copilot in beta, gamma (and test/local dev)
const COPILOT_ENABLED_STAGES: Set<Stage> = new Set([Stage.TEST, Stage.BETA, Stage.GAMMA]);

interface CopilotTriggerProps {
  isAuthenticated: boolean;
}

export function CopilotTrigger({ isAuthenticated }: CopilotTriggerProps) {
  const { state, togglePanel } = useCopilot();

  if (!COPILOT_ENABLED_STAGES.has(CURRENT_STAGE)) return null;
  if (!isAuthenticated || state.isOpen) return null;

  return (
    <div className="copilot-trigger">
      <Button
        variant="primary"
        iconName="gen-ai"
        onClick={togglePanel}
        ariaLabel="Open Astra"
      />
    </div>
  );
}
